import React from "react";
import { motion } from "framer-motion";

const KPI_ANIM = { initial: { opacity: 0, y: 10 }, animate: { opacity: 1, y: 0 } };

export const Kpi = ({ label, value, sub, icon: Icon, accent, testid }) => (
  <motion.div {...KPI_ANIM}
    className="rounded-xl border bg-card p-5 shadow-[0_1px_2px_rgba(15,23,42,0.06)]" data-testid={testid}>
    <div className="flex items-center justify-between">
      <span className="text-sm font-medium text-muted-foreground">{label}</span>
      <Icon className="h-4 w-4" style={{ color: accent }} />
    </div>
    <div className="mt-2 font-display text-3xl font-semibold tabular-nums">{value}</div>
    {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
  </motion.div>
);
